import axios from "../utils/axios";

// 获取公众号第三方授权链接
export function getWxmpPreAuthUrl(params) {
  return axios.postParam("/v2/store/wechat/open/mp/preAuthUrl", params);
}

// 完成公众号第三方授权
export function completeWxmpAuth(params) {
  return axios.postParam("/v2/store/wechat/open/mp/completeAuth", params);
}

// 获取当前店铺已绑定公众号列表
export function getWxmpAuthList() {
  return axios.get("/v2/store/wechat/open/mp/list");
}

// 获取公众号详情
export function getWxmpDetail(id) {
  return axios.get(`/v2/store/wechat/open/mp/${id}/detail`);
}

// 获取第三方授权链接
export function getPreAuthCode(params) {
  return axios.postParam("/v2/store/wxwork/api/third/getPreAuthCode", params);
}

// 获取第三方授权链接
export function setSessionInfo(params) {
  return axios.postParam("/v2/store/wxwork/api/third/setSessionInfo", params);
}

// 获取获取永久授权信息
export function getPermanentCodeInfo(params) {
  return axios.postParam(
    "/v2/store/wxwork/api/third/getPermanentCodeInfo",
    params
  );
}

// 同步员工
export function syncOrganize() {
  return axios.post("/v2/store/wxwork/department/sync");
}

// 获取部门结构
export function getDeparts() {
  return axios.get("/v2/store/wxwork/department/getDeparts");
}

// 获取员工列表
export function getWxuserList(params) {
  return axios.get("/v2/store/wxwork/wxuser/list", params);
}

// 同步客户
export function syncWxworkCustomer() {
  return axios.post("/v2/store/wxwork/customer/sync");
}

// 同步客户详情
export function syncWxworkCustomerDetail(id) {
  return axios.post(`/v2/store/wxwork/customer/${id}/async`);
}

// 获取客户列表
export function getWxcustomerList(params) {
  return axios.get("/v2/store/wxwork/customer/list", params);
}

// 查询企微授权
export function getShopCorps(params) {
  return axios.get("/v2/store/wxwork/corp/shopCorps", params);
}

// 申请代开发应用授权码
export function getCustomizedAuthUrl(params) {
  return axios.get("/v2/store/wxwork/api/service/getCustomizedAuthUrl", params);
}
